import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken} from '@/utils/auth'
import store from '../store'
import {loadLanguageAsync, i18n} from '@/i18n'
import ErrorCatch from '../services/error-catch'
import { IS_RENDERBUS } from '../utils/const'
import { ensureRefreshManagerStarted } from '@/utils/refresh-manager'
import RouterRemake from '../new-router/router-remake'
import { helperAssignChild } from '@/new-router/helper/assignChild'

import adminRoutes from './admin.js'
import authRoutes from './auth.js'
import calculcationRoutes from './calculcation.js'
import copyrightDepositRoutes from './copyright-deposit.js'
import dashbroadRoutes from './dashbroad.js'
import dataGraphRoutes from './data-graph.js'
import dayanTaskRoutes from './dayanTask.js'
import deployRoutes from './deploy.js'
import desktopRoutes from './desktop.js'
import dongleRoutes from './dongle.js'
import exportRoutes from './export.js'
import feedbackRoutes from './feedback.js'
import financeRoutes from './finance.js'
import homeRoutes from './home.js'
import materialRoutes from './material.js'
import monitorRoutes from './monitor.js'
import nodeRoutes from './node.js'
import outsourcingRoutes from './outsourcing.js'
import packRoutes from './pack.js'
import statisticsRoutes from './statistics.js'
import storageRoutes from './storage.js'
import taskRoutes from './task.js'
import transmissionRoutes from './transmission.js'
import userRoutes from './user.js'

Vue.use(Router)

let routes = []

routes = routes.concat(
  adminRoutes,
  authRoutes,
  calculcationRoutes,
  copyrightDepositRoutes,
  dashbroadRoutes,
  dataGraphRoutes,
  dayanTaskRoutes,
  deployRoutes,
  desktopRoutes,
  dongleRoutes,
  exportRoutes,
  feedbackRoutes,
  financeRoutes,
  homeRoutes,
  materialRoutes,
  monitorRoutes,
  nodeRoutes,
  outsourcingRoutes,
  packRoutes,
  statisticsRoutes,
  storageRoutes,
  taskRoutes,
  transmissionRoutes,
  userRoutes
)

export const metaSort = (a, b) => {
  const first = a.meta.sort || 1000
  const second = b.meta.sort || 1000
  return first - second
}
routes.sort(metaSort)

// 各个子路由的模块以父路由的模块为准
routes.forEach(route => {
  if (!route.meta) return false
  if (!route.children || route.children.length === 0) return false
  const modules = route.meta.modules
  route.children.forEach(childrenRoute => {
    childrenRoute.meta.modules = modules
  })
})

routes.push({
  path: '*',
  name: 'default',
  redirect: '/dashbroad',
})

routes.forEach(function mapRouteToFullRouter(item) {
  const path = (item.meta || {}).belong
  if (path) {
    helperAssignChild(path, item, RouterRemake)
  }
  if (item.children) {
    item.children.forEach(mapRouteToFullRouter)
  }
})

export const RouterForSidebar = RouterRemake

let routers = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes,
})

function getScrollBody () {
  return document.querySelector('.main-box')
}

let scrollBody

routers.onError(ErrorCatch.lazyLoadCatch)

routers.beforeEach(async (to, from, next) => {
  const preplatform = parseInt(sessionStorage.getItem('prePlatform'))
  const commonPlatform = parseInt(localStorage.getItem('commonPlatform'))
  if (!parseInt(sessionStorage.getItem('platform'))) {
    store.dispatch('home/updatePlatform', commonPlatform)
  }
  if (preplatform) {
    const routesNeedToUpdatePlatform = [
      'task/renderCompletedDetail',
      'task/renderRunningDetail',
      'user/userInformation',
      'task/preHandleLogDetails',
      'task/analyseEndLogDetails',
      'task/renderRunningLogDetails',
      'task/renderEndLogDetails',
      'dayanTask/sky3RunningDetail',
      'dayanTask/sky3EndDetail',
      'dayanTask/publish',
      'dayanTask/productEndDetail',
      'dayanTask/productRunningDetail',
      'dayanTask/rebuildEndDetail',
      'dayanTask/rebuildRunningDetail',
      'dayanTask/sky3RunningLogDetails',
      'dayanTask/sky3EndLogDetails',
      'dayanTask/productEndLogDetails',
      'dayanTask/productRunningLogDetails',
      'dayanTask/rebuildEndLogDetails',
      'dayanTask/rebuildRunningLogDetails',
    ]
    const curPlatform = IS_RENDERBUS ? 0 : 24
    if (routesNeedToUpdatePlatform.every(route => !to.path.includes(route))) {
      const platformList = store.getters['home/platformList']
      let result = preplatform
      if (!platformList.includes(parseInt(sessionStorage.getItem('platform'))) && platformList.length) result = platformList[0]
      store.dispatch('home/updatePlatform', result || curPlatform)
    }
    sessionStorage.removeItem('prePlatform')
  }
  if (!scrollBody) {
    scrollBody = getScrollBody()
  }
  // 滚动置顶：仅真正的页面跳转（path 变化）才置顶；同路由 query 变化（筛选/搜索等）不置顶
  if (scrollBody && to.path !== from.path) {
    scrollBody.scrollTop = 0
  }
  NProgress.start(to.meta.modules)
  await loadLanguageAsync(i18n.locale, to.meta.modules)
  const dev = process.env.NODE_ENV === 'development'
  if (getToken()) {
    const userInfo = store.dispatch('home/getUserInfo')
    const permission = store.dispatch('home/getAllPermission')
    const area = store.dispatch('home/setAllArea')
    const platforms = store.dispatch('home/getAllPlatforms')
    await Promise.all([userInfo, permission, area, platforms])
    ensureRefreshManagerStarted()
    if (to.path === '/login') {
      next({path: '/dashbroad'})
    }
    // 初始化侧栏打开状态
    // routers.options.routes.forEach(v => { if (!v.hidden && v.meta) v.meta.showSubiems = false })
    const parent = to.matched[to.matched.length - 1].parent
    if (parent) parent.meta.showSubiems = true
    // 重复点击取消NProgress
    if (to.name === from.name) {
      NProgress.done()
    }
    next()
  } else {
    if (!['/bridge', '/login'].includes(to.path) && dev) {
      next({ path: '/login' })
    }
    if (!['/bridge', '/login'].includes(to.path) && !dev) {
      next({path: '/bridge'})
    }
    next()
  }
})

routers.beforeEach((to, from, next) => {
  const permissionList = store.getters['home/permissionList']
  const routePermission = permissionList[to.meta.permission] || {}
  if (!to.meta.permission || routePermission.status) {
    return next()
  }

  next({ path: '/login' })
})

routers.afterEach(() => {
  NProgress.done() // 结束Progress
})

export default routers
